import React , {Component} from 'react';
import { Row } from 'antd';
import "../../asset/style/morpheus.css"
import "../../asset/style/landing.css"

export class Product extends Component {

    render(){
        return(
            <Row className="product-parent full-widther">
                Product
            </Row>
        )
    }
  }